// src/layouts/AuthLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: "#020617",
      }}
    >
      <Outlet />
    </div>
  );
}